// Core
import React, { useState, useEffect } from 'react';
import { Box, Text } from '@chakra-ui/react';

// Components
import RewardsClub from '../Home/components/RewardsClub';

const Download = () => {

  const [deviceType, setDeviceType] = useState('');

  useEffect(() => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    
    if (/android/i.test(userAgent)) {
      setDeviceType('Android');
    } else if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      setDeviceType('iOS');
    } else {
      setDeviceType('Other');
    }
  }, []);

  return (
    <>
      <Text id="download" as="h4" variant="header" fontSize={{base: '24px', md: '32px'}} fontStyle="normal" mt="-60px" pt={{base: '120px', sm: '133px'}} mb={{base: '24px', sm: '32px'}}>Rewards Club</Text>
      <RewardsClub deviceType={deviceType} />

    </>
  );
};

export default Download;